import React, { useEffect, useState } from "react";

import { Tooltip } from "@mui/material";
import Popover from "@mui/material/Popover";
import { colors } from "@zapalacorp/tokens";
import CheckboxComponent from "Components/Form/CheckboxComponent/CheckboxComponent";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../../components/Form";
import { Color } from "../../../../../../components/Form/Button";
import TableOutlineFilterButton from "../../../../../../components/Form/TableOutlineFilterButton/TableOutlineFilterButton";

const imageClose = require("Assets/img/close-icon.svg");

interface Props {
  options: any;
  onFilter: (value: any) => void;
  initialValue?: any[];
}
const SelectStatusShipment = ({ options, onFilter, initialValue }: Props) => {
  const { t: translate } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const id = anchorEl ? "simple-popover" : undefined;
  const [checkboxState, setCheckboxState] = useState<Record<string, boolean>>({});
  const [totalStatusSelected, setTotalStatusSelected] = useState<number>(0);
  const handleCheckboxChange = (value: string, checked: boolean) => {
    setCheckboxState((prev) => ({
      ...prev,
      [value]: checked,
    }));
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setCheckboxState({});
    if (initialValue && initialValue?.length > 0) {
      for (const item of initialValue) {
        setCheckboxState((prev) => ({
          ...prev,
          [item]: true,
        }));
      }
    }
  };

  const handleClearAll = () => {
    setCheckboxState({});
  };

  useEffect(() => {
    if (!initialValue || initialValue.length === 0) {
      setCheckboxState({});
      setTotalStatusSelected(0);

      return;
    }

    const initialState: Record<string, boolean> = {};

    options.forEach((option: any) => {
      initialState[option.value] = initialValue.includes(option.value);
    });
    setCheckboxState(initialState);
  }, [options, initialValue]);

  return (
    <>
      <TableOutlineFilterButton
        onClickHandler={handleClick}
        label={translate("filters")}
        tooltip={translate("filters")}
        countNumber={totalStatusSelected}
      />
      <Popover
        id={id}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{
          "& .MuiPaper-rounded": {
            borderRadius: "12px",
          },
          "& .MuiPaper-elevation8 ": {
            boxShadow:
              " 0px 2px 6px 2px rgba(71, 84, 103, 0.15), 0px 1px 2px 0px rgba(71, 84, 103, 0.30)",
          },
        }}
      >
        {anchorEl && (
          <div
            style={{
              width: "250px",
              padding: "20px",
            }}
          >
            <div
              style={{
                gap: "16px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    color: colors.gray600,
                    fontSize: "14px",
                    fontWeight: 700,
                    lineHeight: "20px",
                    fontStyle: "normal",
                  }}
                >
                  {" "}
                  {translate("filters")}
                </div>
                <img
                  onClick={handleClose}
                  src={imageClose}
                  style={{
                    cursor: "pointer",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "8px",
                  border: "1px solid #E4E7EC",
                  background: "#FCFCFD",
                  gap: "8px",
                  padding: "12px",
                  height: "200px",
                  overflow: "auto",
                }}
              >
                <div
                  style={{
                    color: "#344054",
                    fontSize: "10px",
                    fontStyle: "normal",
                    lineHeight: "15px",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                  }}
                >
                  {" "}
                  {translate("status")}
                </div>
                {options?.map((item: any) => {
                  return (
                    <>
                      <div
                        style={{
                          gap: "6px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <CheckboxComponent
                          checked={checkboxState[item.value] || false}
                          onChange={(e) => handleCheckboxChange(item.value, e.target.checked)}
                        />
                        <div
                          style={{
                            color: colors.gray500,
                            fontFamily: "Manrope",
                            fontSize: "10px",
                            fontStyle: "normal",
                            fontWeight: "400",
                            lineHeight: "16px",
                          }}
                        >
                          {item?.label}
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Tooltip title={translate("common.clearAll")}>
                  <div>
                    <Button
                      disabled={!Object?.values(checkboxState)?.some((value) => value)}
                      customColor={Color.SECONDARY_DARK_OUTLINED}
                      onClick={() => {
                        handleClearAll();
                      }}
                    >
                      {translate("common.clearAll")}
                    </Button>
                  </div>
                </Tooltip>
                <Tooltip title={translate("apply")}>
                  <div>
                    <Button
                      customColor={Color.SECONDARY_DARK}
                      onClick={() => {
                        const selectedKeys = [];

                        for (const [key, value] of Object.entries(checkboxState)) {
                          if (value) {
                            selectedKeys.push(key);
                          }
                        }
                        setTotalStatusSelected(selectedKeys.length);
                        setCheckboxState({});
                        onFilter(selectedKeys);
                        handleClose();
                      }}
                    >
                      {translate("apply")}
                    </Button>
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
        )}
      </Popover>
    </>
  );
};

export default SelectStatusShipment;
